// extracted by mini-css-extract-plugin
export default {"invalidInput":"ErrorLabel_invalidInput__jSly8","yellowLabel":"ErrorLabel_yellowLabel__6Lijy","greenLabel":"ErrorLabel_greenLabel__bj+Rt"};